'use client';

import { useEffect, useState } from 'react';

import { useMediaQuery } from './use-media-query';

/**
 * 모바일 환경 감지 유틸 함수 (non-React 환경용)
 * URL 파라미터 + UserAgent 기반으로 모바일 여부를 판단
 */
export function isMobile(): boolean {
  if (typeof window === 'undefined') return false;
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('mobileUpload') === 'true') return true;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

/**
 * 데스크탑 환경 감지 유틸 함수 (non-React 환경용)
 * isMobile()의 반대 값을 반환
 */
export function isDesktop(): boolean {
  return !isMobile();
}

/**
 * 600px(sm breakpoint) 기준으로 모바일 여부를 반환하는 훅
 * 미디어 쿼리 + URL 파라미터(mobileUpload) + UserAgent를 종합하여 판단
 * @returns {boolean} 600px 미만이거나 모바일 디바이스/URL 파라미터가 true면 true
 */
export function useIsMobile(): boolean {
  const isSmallScreen = useMediaQuery('(max-width: 599px)');
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile());
  }, []);

  // 미디어 쿼리가 모바일이거나 디바이스/URL 파라미터가 모바일이면 true
  return isSmallScreen || isMobileDevice;
}
